'use client';

import { loadPostHog } from './posthog-runtime';
import { createPostHogTracker } from '@upzi/web-shell/analytics';
import { getOrCreateAppIdFromCookiesClient } from './app-id-client';

const tracker = createPostHogTracker({
  getConfig: () => ({
    apiKey: process.env.NEXT_PUBLIC_POSTHOG_KEY,
    host: process.env.NEXT_PUBLIC_POSTHOG_HOST || 'https://us.i.posthog.com',
    appName: 'upzi',
  }),
  getAnonymousId: getOrCreateAppIdFromCookiesClient,
  getDistinctId: async () => (await loadPostHog())?.get_distinct_id(),
  keepalive: true,
});

export const trackPostHogEventClient = tracker.trackEvent;
export const trackShortLinkVisitPostHogClient = tracker.trackShortLinkVisit;
